import React, { useEffect, useState } from 'react'
import { Encounter as FHIREncounter} from '@teschglobal/tg-fhir-react-components/dist/types'
import { Encounter } from '@teschglobal/tg-fhir-react-components'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import { EncounterBundle } from '../../../../../types/FHIRTypes/Bundle'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type EncounterDetailProps = {
    encounterDetailId: string | undefined;
}

const EncounterDetail: React.FC<EncounterDetailProps> = ({encounterDetailId}) => {
    const { patientAccessFhirConfig, handleSelectPractitioner, handleSelectLocation} = useFhirConfig()
     const {
       data: encounter,
       isFetching,
       isLoading,
       isError
     }: UseQueryResult<FHIREncounter, Error> =
       useFhirResourceById('Patient Access', encounterDetailId || '', 'Encounter')
   
     if (isFetching || isLoading) {
       return <FhirLoader />
     }
   
     if (!encounter || isError) {
       return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
     }
   

    return (
        <div>
            <section>
                <Encounter
                    data={encounter}
                    fhirApiConfig={patientAccessFhirConfig}
                    onSelectLocation={handleSelectLocation}
                    onSelectPractitioner={handleSelectPractitioner}
                />
            </section>
        </div>
    )
}

export default EncounterDetail